import React, { PureComponent } from "react"

export default class SideMenu extends PureComponent {
  render () {
    return <a href="#" className="menu-icon" />
  }
}
